import { PROVIDER_LABELS } from "../constants/providerLabels.constant";
import {
  MissionCondition,
  MissionReward,
  MissionRewardType,
} from "../types/mission.type";
import { MissionProvidersTransformer } from "./missionProvidersTransformer";

type ProductDictionary = Record<string, string>;
type ProviderDictionary = Record<string, string>;

export class MissionDetailsTransformer {
  static resolveProductName(
    reward: MissionReward,
    productDictionary: ProductDictionary,
  ): string {
    if (reward.product_name) return reward.product_name;
    if (reward.reward_label) return reward.reward_label;
    if (reward.reward_id) {
      return (
        productDictionary[String(reward.reward_id)] ||
        `Produto ${reward.reward_id}`
      );
    }
    return "--";
  }

  static resolveRewardType(reward: MissionReward): MissionRewardType {
    if (reward.reward_type === "points") return "points";
    if (reward.reward_type === "product") return "product";
    if (reward.reward_type === "tickets") return "tickets";
    if (!reward.reward_id && !reward.product_id) return "points";
    return "product";
  }

  static resolveRewardTypeLabel(reward: MissionReward): string {
    const type = MissionDetailsTransformer.resolveRewardType(reward);
    if (type === "points") return "Pontos";
    if (type === "product") return "Produto";
    if (type === "tickets") return "Bilhetes";
    return type === "points" ? "Pontos" : "Produto";
  }

  static resolveConditionType(
    condition: MissionCondition,
    providerDictionary: ProviderDictionary,
  ): string {
    if (
      condition.provider_klass &&
      providerDictionary[condition.provider_klass]
    ) {
      return providerDictionary[condition.provider_klass];
    }
    if (condition.provider_klass && PROVIDER_LABELS[condition.provider_klass]) {
      return PROVIDER_LABELS[condition.provider_klass];
    }
    if (condition.provider_klass) {
      return (
        MissionProvidersTransformer.humanizeProviderKlass(
          condition.provider_klass,
        ) || condition.provider_klass
      );
    }
    const customLabel =
      condition.properties?.label ||
      condition.properties?.name ||
      condition.type_label;
    if (customLabel && String(customLabel).trim().length > 0) {
      return String(customLabel);
    }
    return "Requisito";
  }
}
